import * as $ from 'jquery';

namespace PFF.controllers.troubleshooting {

	export function init() {
		var $movementLocation = $('.js-part-search-form');
		$movementLocation.empty();
		$('.js-troubleshooting-product-search').appendTo($movementLocation).addClass('state-active');
	}
}

PFF.controllers.troubleshooting.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/troubleshooting.ts